module.exports = __webpack_public_path__ + "img/top_right.708d607f.png";